<sh-language-picker class="d-flex justify-content-end m-2"></sh-language-picker>

<div class="container-fluid" *ngIf="messages.length > 0">
  <ca-system-message
    *ngFor="let message of messages"
    [message]="message"
  ></ca-system-message>
</div>

<div class="login-wrapper">
  <div class="login-form">
    <section>
      <div class="login-logo" e2e-id="login-logo">
        {{ 'shared.branding.shipm8' | translate }}
      </div>
      <p *ngIf="currentForm === 1" e2e-id="reset-password-title">
        {{ 'account.resetPassword.title' | translate }}
      </p>
      <form
        *ngIf="currentForm === 0"
        #loginForm="ngForm"
        (ngSubmit)="loginForm.submitted && loginForm.valid && login()"
        e2e-id="login-form"
      >
        <div class="form-group">
          <label class="control-label" for="Username" e2e-id="username-label">{{
            'account.terms.username' | translate
          }}</label>
          <input
            #username="ngModel"
            [(ngModel)]="loginModel.username"
            required
            id="Username"
            name="Username"
            type="text"
            class="form-control form-control-lg"
            e2e-id="username-input"
          />
          <span
            *ngIf="
              loginForm.submitted &&
              username.errors &&
              username.errors['required']
            "
            class="text-danger"
            e2e-id="username-required-error"
          >
            {{ 'account.login.error.emptyUsername' | translate }}
          </span>
        </div>
        <div class="form-group">
          <label class="control-label" for="Password" e2e-id="password-label">{{
            'account.terms.password' | translate
          }}</label>
          <input
            #password="ngModel"
            [(ngModel)]="loginModel.password"
            required
            id="Password"
            name="Password"
            type="password"
            class="form-control form-control-lg"
            e2e-id="password-input"
          />
          <span
            *ngIf="
              loginForm.submitted &&
              password.errors &&
              password.errors['required']
            "
            class="text-danger"
            e2e-id="password-required-error"
          >
            {{ 'account.login.error.emptyPassword' | translate }}
          </span>
        </div>
        <div class="d-flex justify-content-between mb-3">
          <div class="form-group my-0">
            <div class="form-check">
              <input
                [(ngModel)]="loginModel.rememberMe"
                id="RememberMe"
                name="RememberMe"
                type="checkbox"
                class="form-check-input"
                e2e-id="remember-me-checkbox"
              />
              <label
                class="form-check-label"
                for="RememberMe"
                e2e-id="remember-me-label"
              >
                {{ 'account.login.rememberMe' | translate }}
              </label>
            </div>
          </div>
          <button
            (click)="currentForm = 1"
            type="button"
            class="btn btn-link p-0 border-none"
            e2e-id="forgot-password-link"
          >
            {{ 'account.login.forgotPassword' | translate }}
          </button>
        </div>
        <div
          *ngIf="loginResponse?.message"
          class="form-group alert alert-danger"
          e2e-id="login-error-message"
        >
          {{ loginResponse.message | translate }}
        </div>
        <sh-loading-indicator
          class="text-center"
          *ngIf="isLoading"
          e2e-id="loading-indicator"
        ></sh-loading-indicator>
        <div class="d-flex justify-content-between">
          <a
            href="https://shipm8.com/"
            class="small my-auto"
            e2e-id="website-link"
            >{{ 'account.login.website' | translate }}
          </a>

          <div class="d-flex justify-content-between">
            <button
              type="submit"
              class="btn btn-primary btn-lg"
              e2e-id="login-button"
            >
              {{ 'account.login.login' | translate }}
            </button>
          </div>
        </div>
      </form>
      <form
        *ngIf="currentForm === 1"
        #resetPasswordForm="ngForm"
        (ngSubmit)="resetPassword(resetPasswordForm)"
        e2e-id="reset-password-form"
      >
        <div class="form-group">
          <label class="control-label" for="emailAddress" e2e-id="email-label"
            >{{ 'shared.terms.email' | translate }}
          </label>
          <input
            #emailAddress="ngModel"
            [(ngModel)]="resetPasswordForm.emailAddress"
            required
            id="emailAddress"
            name="emailAddress"
            type="email"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            class="form-control"
            e2e-id="email-input"
          />
        </div>
        <div class="d-flex">
          <button
            (click)="currentForm = 0"
            type="button"
            class="btn btn-link p-0 ml-auto"
            e2e-id="back-to-login-link"
          >
            {{ 'account.login.backToLogin' | translate }}
          </button>
        </div>
        <button
          [disabled]="emailAddress.invalid || isResetPassword"
          type="submit"
          class="btn btn-primary"
          e2e-id="reset-password-button"
        >
          <span *ngIf="isResetPassword">
            <i class="fa-regular fa-spinner fa-spin fa-fw"></i>
          </span>
          {{ 'account.resetPassword.title' | translate }}
        </button>
      </form>

      <form
        *ngIf="currentForm === 2 && !redirecting"
        #mfaForm="ngForm"
        (ngSubmit)="sendVerificationCode(verificationCodeControl.value)"
        e2e-id="mfa-form"
      >
        <div class="form-group">
          <label
            class="control-label text-center mb-3"
            for="VerificationCode"
            e2e-id="verification-code-label"
          >
            {{ 'user.mfa.verificationCode.login' | translate }}
          </label>
          <input
            #verificationCodeControl="ngModel"
            [(ngModel)]="verificationCode"
            required
            id="verificationCode"
            name="VerificationCode"
            class="form-control form-control-lg"
            e2e-id="verification-code-input"
          />
          <span
            *ngIf="
              mfaForm.submitted &&
              verificationCodeControl.errors &&
              verificationCodeControl.errors['required']
            "
            class="text-danger"
            e2e-id="verification-code-required-error"
          >
            {{ 'user.mfa.verificationCodeRequired' | translate }}
          </span>
        </div>
        <sh-loading-indicator
          class="text-center"
          *ngIf="isLoading"
        ></sh-loading-indicator>
        <div class="d-flex justify-content-between">
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            e2e-id="verify-button"
          >
            {{ 'shared.terms.verify' | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-link"
            (click)="currentForm = 0; redirecting = false"
            e2e-id="mfa-back-to-login-button"
          >
            {{ 'shared.terms.backToLogin' | translate }}
          </button>
        </div>
      </form>

      <div
        *ngIf="currentForm === 3 && !redirecting"
        e2e-id="mfa-setup-container"
      >
        <sh-mfa-setup #mfaSetup [setupCode]="mfaSetupCode"></sh-mfa-setup>
        <div class="d-flex justify-content-between mt-2">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            (click)="completeMfa()"
            e2e-id="confirm-mfa-button"
          >
            {{ 'shared.terms.confirm' | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-link"
            (click)="currentForm = 0; redirecting = false"
            e2e-id="mfa-setup-back-to-login-button"
          >
            {{ 'shared.terms.backToLogin' | translate }}
          </button>
        </div>
      </div>

      <div class="ml-auto" *ngIf="redirecting" e2e-id="redirecting-message">
        <div>{{ 'shared.terms.redirecting' | translate }}...</div>
      </div>
    </section>
  </div>
</div>
